import { supabase } from "@/integrations/supabase/client";
import type { SignUpWithPasswordCredentials } from "@supabase/supabase-js";

// ── User ──

export function getUser() {
  return supabase.auth.getUser();
}

export function getSession() {
  return supabase.auth.getSession();
}

// ── Auth state ──

export function onAuthStateChange(
  callback: Parameters<typeof supabase.auth.onAuthStateChange>[0],
) {
  return supabase.auth.onAuthStateChange(callback);
}

// ── Sign in / Sign up / Sign out ──

export function signInWithPassword(email: string, password: string) {
  return supabase.auth.signInWithPassword({ email, password });
}

export function signUp(credentials: SignUpWithPasswordCredentials) {
  return supabase.auth.signUp(credentials);
}

export function signOut(scope?: "global" | "local" | "others") {
  return supabase.auth.signOut(scope ? { scope } : undefined);
}

// ── Password / OTP ──

export function updateUser(data: Parameters<typeof supabase.auth.updateUser>[0]) {
  return supabase.auth.updateUser(data);
}

export function resetPasswordForEmail(
  email: string,
  options?: { redirectTo?: string },
) {
  return supabase.auth.resetPasswordForEmail(email, options);
}

export function verifyOtp(params: Parameters<typeof supabase.auth.verifyOtp>[0]) {
  return supabase.auth.verifyOtp(params);
}

// ── Double authentification (TOTP), exigée du seul mode support ──

/** `data.totp` ne contient que les facteurs VÉRIFIÉS ; `data.all`, aussi les enrôlements abandonnés. */
export function listMfaFactors() {
  return supabase.auth.mfa.listFactors();
}

export function enrollTotpFactor(friendlyName: string) {
  return supabase.auth.mfa.enroll({ factorType: "totp", friendlyName, issuer: "Equiply" });
}

/** Succès ⇒ la session passe en aal2 et le SDK émet `MFA_CHALLENGE_VERIFIED`. */
export function verifyTotpCode(factorId: string, code: string) {
  return supabase.auth.mfa.challengeAndVerify({ factorId, code });
}

export function unenrollMfaFactor(factorId: string) {
  return supabase.auth.mfa.unenroll({ factorId });
}

// ── Edge Functions ──

export function invokeEdgeFunction(name: string, body: Record<string, unknown>) {
  return supabase.functions.invoke(name, { body });
}
